export const USER_INFO = 'apm-user-info';
